export enum HotelReviewSourceType {
    All = -1,
    Sletat = 0,
    TourPravda = 1,
    TripAdvisor = 2,
    TopHotels = 3,
    Booking = 4,
}

export const HOTEL_REVIEWS_SOURCES_LIST = [
    'Sletat',
    'TourPravda',
    'TripAdvisor',
    'TopHotels',
    'Booking'
];

export enum SortByType {
    Positive = 0,
    Negative = 1,
    Newest = 2,
    Oldest = 3,
}

export enum ReviewsSources {
    Others = 'Others',
    TopHotels = 'TopHotels',
}

export interface Hit {
    start: number;
    end: number;
    length: number;
}

export interface Hits {
    [key: string]: Array<Hit>;
}

export interface Tag {
    id: number;
    displayName: string;
}

type TagId = string;
type AmountOfReviewsWithTag = number;

export type RenderedTagType = [TagId, AmountOfReviewsWithTag];

export interface ReviewsAmountByGrade {
    Good: number;
    Medium: number;
    Bad: number;
}

export interface AmountBySeasons {
    Summer: number;
    Spring: number;
    Winter: number;
    Fall: number;
}

export interface HotelReviewsReq {
    data: HotelReviewsDataReq | null;
    error: {
        errorCode?: number
        reason?: string
    } | null;
}

export interface TagsCount {
    [key: string]: number;
}

export interface ReviewOverview {
    averageReviewsRating: number;
    amountBySeasons: AmountBySeasons;
    amountByRatingType: ReviewsAmountByGrade;
    reviewsWithPhotoAvailable: number;
    reviewsWithDetailedTextAvailable: number;
    reviewsWithDetailedRatingsAvailable: number;
    additionalRatingsAverage: AdditionalRating;
    additionalRatingsCount: AdditionalRating;
    tagsCount: TagsCount;
}

export interface HotelReviewsDataReq {
    availableTags: Array<Tag>;
    foundSources: Array<number>;
    itemsPerPage: number;
    page: number;
    results: Array<HotelReview>;
    total: number;
    overview: ReviewOverview;
}

export interface HotelReview {
    creationDate?: string;
    leaveDate?: string;
    hotelId?: number;
    negativeFeedback?: string;
    negativeHits?: Hits;
    positiveFeedback?: string;
    positiveHits?: Hits;
    rating?: number;
    reporterName?: string;
    userAvatar?: string;
    sourceKind: number;
    title?: string;
    visitDate?: string;
    managementResponse?: string;
    managementResponseDate?: string;
    additionalRatings?: any; // тип добавить
    photos?: string[];
    tripType?: TripType;
    // TODO: ниже - это временные типы, не готово на бэке
    roomType?: string | null;
}

export enum RatingGrade {
    Max = 10,
    Good = 7,
    Medium = 6,
    Bad = 5,
    Min = 1,
}

export enum ReviewRatingType {
    Good  = 0,
    Medium  = 1,
    Bad = 2,
}

export enum RatingWordType {
    Bad = 'Bad',
    Medium = 'Medium',
    Good = 'Good',
}

export enum ParamsFilterType {
    WithPhoto = 'with_photo',
    WithDetailedText = 'detailed_text',
    WithDetailedRatings = 'detailed_rating',
}

export enum Category {
    Room = 'Room',
    Location = 'Location',
    Service = 'Service',
    PriceQuality = 'PriceQuality',
    Clean = 'Clean',
    Meal = 'Meal',
}

export enum CategoryRu {
    Room = 'Номера',
    Location = 'Расположение',
    Service = 'Обслуживание',
    PriceQuality = 'Цена/качество',
    Clean = 'Чистота',
    Meal = 'Питание',
}

export type AdditionalRating = {
    [key in Category]: number
};

export enum TripType {
    Business = 'BUSINESS',
    Couple = 'COUPLES',
    Family = 'FAMILY',
    Friends = 'FRIENDS',
    Solo = 'SOLO',
    Null = 'NULL',
    None = 'NONE'
}

export enum SeasonsType {
    Spring = 'Spring',
    Summer = 'Summer',
    Fall = 'Fall',
    Winter = 'Winter',
}

type TMonth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 0;

export interface MonthIntervalTypes {
    from: TMonth;
    to: TMonth;
}

export interface PayloadType {
    offset: number;
    amount: number;
    sources: number[];
    monthIntervals: MonthIntervalTypes[];
    withPhotos?: boolean;
    withDetailedText?: boolean;
    withDetailedRatings?: boolean;
    sortBy?: SortByType;
    tags: number[];
}

export const MONTHS = {
    '1': 'Winter',
    '2': 'Winter',
    '3': 'Spring',
    '4': 'Spring',
    '5': 'Spring',
    '6': 'Summer',
    '7': 'Summer',
    '8': 'Summer',
    '9': 'Fall',
    '10': 'Fall',
    '11': 'Fall',
    '12': 'Winter',
};

export interface ReviewsAmountBySeasonsType {
    Winter: number;
    Spring: number;
    Summer: number;
    Fall: number;
}

export const SEASONS = [
    {
        label: SeasonsType.Spring,
        inputName: 'март-май',
    },
    {
        label: SeasonsType.Summer,
        inputName: 'июнь-август',
    },
    {
        label: SeasonsType.Fall,
        inputName: 'сентябрь-ноябрь',
    },
    {
        label: SeasonsType.Winter,
        inputName: 'декабрь-февраль',
    },
];

export enum AdaptiveType {
    IsDesktop = 'isDesktop',
    IsTabletL = 'isTabletL',
    IsTabletS = 'isTabletS',
    IsMobile = 'isMobile'
}

export enum WindowWidthSize {
    W980 = 980,
    W768 = 768,
    W520 = 520,
}
